import {
  publicInstance,
  setPrivateInstanceHeader,
  privateInstance,
  nohandlerPrivateInstance
} from "../configs";

export const authApi = {
  async login(authData) {
    const res = await publicInstance.post("/api-token-auth/", {
      username: authData.username,
      password: authData.password,
      returnSecureToken: true
    });
    setPrivateInstanceHeader(res.data.token);
    return res.data;
  },
  async refreshToken(token) {
    const res = await publicInstance.post("/api-token-refresh/", {
      token
    });
    setPrivateInstanceHeader(res.data.token);
    return res.data;
  },
  async verifyToken(token) {
    const res = await publicInstance.post("/api-token-verify/", { token });
    return res;
  },
  async postAdminLogin(password) {
    const res = await nohandlerPrivateInstance.post("main/api/admin/login/", {
      password: password
    });
    return res;
  },
  async putUserPassword(data) {
    const res = await privateInstance.put("main/api/user/password/", data);
    return res.data;
  },
  async putAdminPassword(data) {
    const res = await privateInstance.put("main/api/admin/password/", data);
    return res.data;
  },
  async patchUser(data) {
    const res = await privateInstance.patch("main/api/user/settings/", data);
    return res.data;
  },
  async getCustomerPortal() {
    const res = await privateInstance.get("main/api/customer/portal/");
    return res.data;
  },
  async sendInfosRequest(data) {
    const res = await publicInstance.post("main/api/infos/send/", data);
    return res;
  }
};
